// DO NOT EDIT — generated from platform.config.json by `pnpm platform:generate`.
// Edit platform.config.json and re-run the generator instead (apps/admin/src/generated/platform-client.ts).

/** Games this client deployed (Layer A), baked at build time. */
export const ENABLED_GAMES = ['pickem', 'lobby'] as const;

/** Enabled games as sports-config GameTypeCode values (matches GAME_TYPES[].code). */
export const ENABLED_GAME_CODES = ['pickem'] as const;

/** Sports this client deployed, as sports-config SportCode values (matches SUPPORTED_SPORTS[].code). */
export const ENABLED_SPORT_CODES = ['FOOTBALL', 'BASKETBALL', 'BASEBALL', 'HOCKEY', 'SOCCER', 'CRICKET'] as const;

/** Tenant featureConfig sections to show in the admin Features tab (same strings as the game codes). */
export const ENABLED_FEATURE_SECTIONS = ['pickem'] as const;

/** Content Locales a Game Manager authors Contest and Question text in, primary first. */
export const CONTENT_LOCALES = ['en'] as const;

/**
 * Whether this client has a sports feed. False hides every surface that reads fixtures,
 * teams, players or live stats — the backend does not register those routes either.
 */
export const FEED_ENABLED = false;

/**
 * The auth provider this instance runs. Baked in because the admin has to know which
 * credentials a tenant actually needs — showing every provider's fields would offer a Game
 * Manager settings this instance will never read.
 */
export const AUTH_PROVIDER = 'clerk' as const;

/**
 * Whether this client ships a logo cut for dark surfaces. False means render no logo on
 * dark rather than a broken image — the file is simply not emitted.
 */
export const HAS_BRAND_LOGO_ON_DARK = true;

/**
 * Canonical public origin for each frontend this client deploys, per environment, taken
 * from `frontends[].origins` — first entry wins, which is the custom domain where one is
 * declared. The admin uses these to build "open the public page" links.
 *
 * Derived rather than written down. These were a hardcoded table of the founding client's
 * hosts, so every other client's admin offered a link to THAT operator's lobby and
 * pick'em. An app with no origin declared for an environment is simply absent here, and
 * callers render no link rather than guessing.
 */
export const PUBLIC_APP_ORIGINS: Readonly<
  Record<string, Readonly<Partial<Record<'dev' | 'staging' | 'production', string>>>>
> = {
  'frontend': {
    dev: 'https://victorious-tree-03d1d6310.7.azurestaticapps.net',
    production: 'https://pickem-zappx-prod.low6.com',
  },
  'lobby': {
    dev: 'https://happy-moss-0506c2e10.7.azurestaticapps.net',
    production: 'https://zappx-lobby-prod.low6.com',
  },
};
